import { MediaLibCategoryEnum } from "../../types";
import type { IMediaLibPanelCategory } from "./types";

export const MEDIA_LIB_PANEL_MASONRY_GAPS = 8;
export const MEDIA_LIB_PANEL_MASONRY_COLS = 3;
export const MEDIA_LIB_PANEL_MASONRY_FAKE_CELLS = 3;

export const MEDIA_LIB_PANEL_MASONRY_SKELETON_HEIGHTS = [
  [67, 86, 162],
  [127, 67, 162],
  [186, 87, 122],
];

export const MEDIA_LIB_PANEL_CATEGORIES: IMediaLibPanelCategory[] = [
  {
    key: MediaLibCategoryEnum.AllFiles,
    label: "All files",
  },
  {
    key: MediaLibCategoryEnum.Images,
    label: "Images",
  },
  {
    key: MediaLibCategoryEnum.Videos,
    label: "Videos",
  },
  {
    key: MediaLibCategoryEnum.BrandAssets,
    label: "Brand assets",
  },
  {
    key: MediaLibCategoryEnum.Website,
    label: "From Website",
  },
  {
    key: MediaLibCategoryEnum.Import,
    label: "From PPT/PDF",
  },
  {
    key: MediaLibCategoryEnum.Archive,
    label: "Archived",
  },
];
